'use client';

import React, { createContext, useContext } from 'react';
import { TrustpilotRating } from '@/integrations/trustpilot/types';

const TrustpilotContext = createContext<TrustpilotRating | null>(null);

interface TrustpilotProviderProps {
  rating: TrustpilotRating | null;
  children: React.ReactNode;
}

/**
 * Makes the server-fetched Trustpilot rating available to client tiles. The value is
 * read-through cached and resolved in the server layout, so tiles get it synchronously during
 * SSR — no client fetch, no useEffect, no flash.
 */
export function TrustpilotProvider({ rating, children }: Readonly<TrustpilotProviderProps>) {
  return <TrustpilotContext.Provider value={rating}>{children}</TrustpilotContext.Provider>;
}

export function useTrustpilot(): TrustpilotRating | null {
  return useContext(TrustpilotContext);
}
